import lang from './lang';
import pageTitle from './pageTitle';

export default {
    lang,
    pageTitle,
};
